import type { Editor } from '@tiptap/core';
import { TBlockItemType } from '../types';

// U+FFFC (object replacement character) as sentinel for leaf atom nodes
// (dropdowns, inline blocks, etc.). We cannot use '\n' because text content
// may contain literal newlines (e.g. multiline LaTeX in Mathematics extension).
const LEAF_SENTINEL = '\uFFFC';

const inferSelectionKind = (editor: Editor): TBlockItemType | null => {
  const { selection } = editor.state;
  const { empty, from, to, $from, $to } = selection;

  if (empty) {
    return null;
  }

  // Multi-textblock selections contain structural nodes (paragraphs, lists) that can't fit in an inline block.
  const singleTextBlock = $from.sameParent($to) && $from.parent.isTextblock;
  if (!singleTextBlock) {
    return 'DOCUMENT';
  }

  const text = editor.state.doc.textBetween(from, to, '\n', LEAF_SENTINEL).trim();
  if (!text) {
    return null;
  }
  if (text.includes(LEAF_SENTINEL)) {
    return 'DOCUMENT';
  }

  return 'INLINE_BLOCK';
};

export default inferSelectionKind;
